const csrfToken = () => document.querySelector('meta[name="csrf-token"]')?.content;
let requestSequence = 0;

const cacheSafeUrl = (url, method) => {
  if (method !== "GET") return url;

  requestSequence += 1;
  const requestId = globalThis.crypto?.randomUUID?.() ||
    `${globalThis.performance?.timeOrigin || Date.now()}-${requestSequence}`;
  const [path, fragment] = String(url).split("#", 2);
  const separator = path.includes("?") ? "&" : "?";
  const suffix = fragment == null ? "" : `#${fragment}`;
  return `${path}${separator}_sw_bypass=${encodeURIComponent(requestId)}${suffix}`;
};

const errorMessage = (text, status) => {
  if (!text) return status ? `HTTP ${status}` : "Ошибка запроса";

  try {
    const data = JSON.parse(text);
    return data.errors?.join?.(", ") || data.error || text;
  } catch {
    return text;
  }
};

const requestResponse = async (url, options, defaultHeaders) => {
  const method = String(options.method || "GET").toUpperCase();
  const isFormData = typeof FormData !== "undefined" && options.body instanceof FormData;
  const { "Content-Type": defaultContentType, ...baseHeaders } = defaultHeaders;
  const headers = {
    "X-CSRF-Token": csrfToken(),
    "X-Requested-With": "XMLHttpRequest",
    ...baseHeaders,
    ...options.headers
  };
  if (!isFormData && defaultContentType && !headers["Content-Type"]) {
    headers["Content-Type"] = defaultContentType;
  }

  const response = await fetch(cacheSafeUrl(url, method), {
    ...options,
    cache: "no-store",
    headers
  });
  if (!response.ok) {
    const text = await response.text();
    const error = new Error(errorMessage(text, response.status));
    try { error.payload = text ? JSON.parse(text) : null; } catch { error.payload = null; }
    error.status = response.status;
    throw error;
  }
  return response;
};

export const requestJson = async (url, options = {}) => {
  const response = await requestResponse(url, options, {
    Accept: "application/json",
    "Content-Type": "application/json"
  });
  const text = await response.text();
  return text ? JSON.parse(text) : null;
};

export const requestArrayBuffer = async (url, options = {}) => {
  const response = await requestResponse(url, options, { Accept: "application/octet-stream" });
  return response.arrayBuffer();
};

export default requestJson;
